const env = {
REACT_APP_SERVER_ENV: "int",
REACT_APP_CONTEXT_COUNTRY: "co",
REACT_APP_GOOGLE_TAG_MANAGER: "GTM-WZ3S468",
REACT_APP_HELP_CENTER_BFF_URL: "/backoffice/bff/merchant-help-center/v1",
REACT_APP_NAME: "merchant-help-center",
REACT_APP_PUBLIC_PATH: "/sellers",
REACT_APP_RECAPTCHA_KEY: "6LfobzggAAAAALA7gtlK5twrH9Iw1AlahKX-fmtJ",
REACT_APP_WIDGET_EVENT: "prodfpaytest",
REACT_APP_WIDGET_SCRIPT: "https://apollo-public.loyal.ink/survey/ZnBheS90ZXN0LWZwYXk=.js",
REACT_APP_WIDGET_TAG: "apollo-ZnBheS90ZXN0LWZwYXk=",
}
export default env
